<template>
  <div class="navbar">
    <logo class="header-logo" :linked="!oneTimeAccess" />
    <div class="links" v-if="authenticated">
      <a class="header-link" @click="submitLogout">Logout</a>
      <a
        v-if="!oneTimeAccess"
        class="header-link button-header-link"
        @click="newProvider"
        >Create</a
      >
      <!-- <router-link tag="a" class="header-link" :to="{ name: 'review' }"
        >Review</router-link
      > -->
      <router-link
        v-if="!oneTimeAccess"
        tag="a"
        class="header-link"
        :to="{ name: 'search' }"
        >Search</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import logo from "./logo.vue";

export default {
  name: "nav-bar",
  props: ["routeNames"],
  components: {
    logo: logo
  },
  computed: {
    ...mapGetters({
      authenticated: "authenticated",
      newProviderPosted: "newProviderPosted",
      next: "next",
      prev: "prev",
      isCreateMode: "isCreateMode",
      isNullMode: "isNullMode",
      oneTimeAccess: "oneTimeAccess"
    })
  },
  methods: {
    ...mapActions(["addMessage"]),
    newProvider: function() {
      this.$store.commit("setCreateMode");
      this.$store.commit("createNewProvider");
      this.$router.push({ name: "provider" });
    },
    submitLogout: function() {
      this.$store.dispatch("logout").then(() => {
        this.username = "";
        this.password = "";
      });
      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style scoped>
.header-logo {
  float: left;
  padding: 2px 10px;
  padding-left: 7.5vw;
  font-size: 35px;
}
.navbar .links {
  margin-top: 10px;
  float: right;
  font-family: "Helvetica Neue", sans-serif !important;
}

.links {
  padding-right: 7.5vw;
}

.navbar .links a {
  text-decoration: none;
  text-transform: uppercase;
  color: #95a5a6;
  font-size: 11px;
  letter-spacing: 2px;
  font-weight: 600;
}
.navbar .links a:hover {
  color: #32a6ae;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/elements/navBar.vue